/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Ovmsa_DetailInputs */



/**
* | output |
* | --- |
* | "Support against OCIMF's Offshore Vessel Management and Self-Assessment (OVMSA) programme, the offshore counterpart to TMSA. We help offshore operators assess..." |
*
* @param {Service_Ovmsa_DetailInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_ovmsa_detail = /** @type {((inputs?: Service_Ovmsa_DetailInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Ovmsa_DetailInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("对照 OCIMF 海上船舶管理与自评估（OVMSA）项目提供支持，该项目是 TMSA 在海工领域的对应版本。我们帮助海工运营方评估管理体系、准备佐证材料并规划改进。")
	return /** @type {LocalizedString} */ ("Support against OCIMF's Offshore Vessel Management and Self-Assessment (OVMSA) programme, the offshore counterpart to TMSA. We help offshore operators assess and evidence their management systems and plan improvements.")
});